import React, { useEffect } from "react";
import { FaPen } from "react-icons/fa";

const EditUserModal = ({
    showModal,
    setShowModal,
    editData,
    setEditData,
    handleSubmit,
    loading,
    isEdit
}) => {

    const handleClose = () => setShowModal(false);

    const handleChange = (field, value) => {
        setEditData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // ESC close
    useEffect(() => {
        const esc = (e) => e.key === "Escape" && handleClose();
        document.addEventListener("keydown", esc);
        return () => document.removeEventListener("keydown", esc);
    }, []);

    if (!showModal) return null;

    return (
        <div className="oms-overlay">
            <div className="oms-modal">

                {/* HEADER */}
                <div className="oms-modal-head">
                    <span className="oms-modal-title">
                        <FaPen size={16} className="me-2" />
                        {isEdit ? "Edit User" : "Add User"}
                    </span>
                    <button className="oms-icon-btn" onClick={handleClose}>✕</button>
                </div>

                {/* BODY */}
                <div className="oms-modal-body">
                    <div className="oms-form-grid">

                        {/* FIRST NAME */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">First Name</label>
                            <input
                                className="oms-form-input"
                                value={editData.firstName || ""}
                                onChange={(e) => handleChange("firstName", e.target.value)}
                            />
                        </div>

                        {/* LAST NAME */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Last Name</label>
                            <input
                                className="oms-form-input"
                                value={editData.lastName || ""}
                                onChange={(e) => handleChange("lastName", e.target.value)}
                            />
                        </div>

                        {/* USERNAME */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">User Name</label>
                            <input
                                className="oms-form-input"
                                value={editData.userName || ""}
                                onChange={(e) => handleChange("userName", e.target.value)}
                            />
                        </div>

                        {/* ROLE */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Role</label>
                            <select
                                className="oms-form-input"
                                value={editData.role || "user"}
                                onChange={(e) => handleChange("role", e.target.value)}
                            >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>

                        {/* PASSWORD (ONLY ADD) */}
                        {!isEdit && (
                            <div className="oms-form-group oms-form-full">
                                <label className="oms-form-label">Password</label>
                                <input
                                    type="password"
                                    className="oms-form-input"
                                    value={editData.password || ""}
                                    onChange={(e) => handleChange("password", e.target.value)}
                                />
                            </div>
                        )}

                    </div>
                </div>

                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="oms-btn oms-btn-primary"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : isEdit ? "Update User" : "Add User"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default EditUserModal;